module.exports = __webpack_public_path__ + "static/media/7.9794a7a9.jpeg";